/* ==========================================================================
   Meridian - PDP buy box
   Qty stepper, variant price sync, live multi-buy discount hint, gallery
   thumbnail swap, and add-to-cart via the shared cart-drawer event so the
   PDP behaves identically to every other add-to-cart control on the site.
   ========================================================================== */
(function () {
  'use strict';

  function moneyFormat(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  document.querySelectorAll('[data-product-form]').forEach(initForm);

  function initForm(form) {
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyValue = form.querySelector('[data-qty-value]');
    var incBtn = form.querySelector('[data-qty-increase]');
    var decBtn = form.querySelector('[data-qty-decrease]');
    var variantIdInput = form.querySelector('[data-variant-id]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var submitBtn = form.querySelector('[data-add-submit]');
    var lineTotalEl = form.querySelector('[data-line-total]');
    var priceEl = document.querySelector('[data-product-price]');
    var hintEl = document.querySelector('[data-discount-hint]');

    var basePrice = parseInt(submitBtn ? submitBtn.getAttribute('data-base-price') : 0, 10) || 0;

    var tier1Qty = hintEl ? parseInt(hintEl.getAttribute('data-tier1-qty'), 10) || 3 : 3;
    var tier1Pct = hintEl ? parseInt(hintEl.getAttribute('data-tier1-pct'), 10) || 10 : 10;
    var tier2Qty = hintEl ? parseInt(hintEl.getAttribute('data-tier2-qty'), 10) || 5 : 5;
    var tier2Pct = hintEl ? parseInt(hintEl.getAttribute('data-tier2-pct'), 10) || 15 : 15;

    function rateFor(count) {
      if (count >= tier2Qty) return tier2Pct / 100;
      if (count >= tier1Qty) return tier1Pct / 100;
      return 0;
    }

    function currentQty() {
      return parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    }

    function render() {
      var qty = currentQty();
      if (qtyValue) qtyValue.textContent = qty;
      if (lineTotalEl) lineTotalEl.textContent = moneyFormat(basePrice * qty);

      if (hintEl) {
        var rate = rateFor(qty);
        if (rate > 0) {
          hintEl.textContent = 'Multi-buy saving applied - ' + (rate * 100) + '% off at checkout';
        } else {
          var remaining = tier1Qty - qty;
          hintEl.textContent = 'Add ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' for ' + tier1Pct + '% off';
        }
      }
    }

    if (incBtn) incBtn.addEventListener('click', function () {
      qtyInput.value = currentQty() + 1;
      render();
    });
    if (decBtn) decBtn.addEventListener('click', function () {
      qtyInput.value = Math.max(1, currentQty() - 1);
      render();
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        variantIdInput.value = variantSelect.value;
        var priceMatch = opt.textContent.match(/[\d,.]+/);
        // price text isn't machine-friendly; re-derive from a data attribute instead if present
        if (opt.getAttribute('data-price')) {
          basePrice = parseInt(opt.getAttribute('data-price'), 10);
          if (priceEl) priceEl.textContent = moneyFormat(basePrice);
          render();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = currentQty();
      var accentSwatch = document.querySelector('.m-pdp__price');
      document.dispatchEvent(new CustomEvent('meridian:add-to-cart', {
        detail: {
          items: [{
            id: parseInt(variantIdInput.value, 10),
            quantity: qty,
            properties: { _accent_colour: accentSwatch ? accentSwatch.style.color : '' }
          }],
          flashText: 'Added - ×' + qty
        }
      }));
    });

    render();
  }

  // Gallery thumbnail swap
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var hero = document.querySelector('.m-pdp__hero-media');
      if (full && hero) hero.style.backgroundImage = "url('" + full + "')";
    });
  });
})();
